<ng-container *ngIf="state$ | async as state">
  <div class="top-navigation-tools">
    <ul class="nav">
      <li *ngIf="state.supportsAccountCreation"
          [class.d-block]="state.isMobileNavigationOpened"
          class="d-none"
          data-cy="navigation-categories-my-account"
      >
        <mb-link [linkData]="{uid: cmsLinkType.CONTENT_LINK, url: 'myAccount'}"
                 [isCxRoute]="true"
                 [useSlot]="true"
                 (clickEvent)="sendGTMEvent.emit($event)"
                 styleClass="mobile-entry"
                 dataEventAction="Click Tools-Account"
                 dataEventCategory="IconNavi"
                 data-link="/myaccount"
                 dataCy="navigation-my-account-icon"
        >
        <span class="mb-mobile-navigation-link">
          <img [src]="state.userIsLoggedIn ? '/assets/images/Icon_user-loc.svg' : '/assets/images/Icon_user.svg'"
               alt="my account"
               data-icon="user"
               title="my account"
          >
        </span>
          <span [innerHTML]="'navigation.login' | cxTranslate"></span>
        </mb-link>
      </li>

      <li *ngIf="!state.supportsGuestCheckout"
          [class.d-block]="state.isMobileNavigationOpened"
          class="d-none"
          data-cy="navigation-categories-wishlist"
      >
        <mb-link [linkData]="{uid: cmsLinkType.CONTENT_LINK, url: 'myWishlist'}"
                 [useSlot]="true"
                 [isCxRoute]="true"
                 (clickEvent)="sendGTMEvent.emit($event)"
                 styleClass="mobile-entry"
                 data-current-node=""
                 dataCy="navigation-favorites-icon"
                 dataEventAction="Click Tools-Fav"
                 dataEventCategory="IconNavi"
                 data-link="/myaccount/wishlist"
        >
        <span class="mb-mobile-navigation-link">
          <img alt="favorite list"
               data-icon="favorites"
               src="/assets/images/icons-2/Icon_header_heart.svg"
               title="favorite list"
          >
        </span>
          <span [innerHTML]="'navigation.wishList' | cxTranslate"></span>
        </mb-link>
      </li>

      <li [class.d-block]="state.isMobileNavigationOpened"
          class="d-none"
          data-cy="navigation-categories-contact-box-list-item"
      >
        <div aria-multiselectable="true"
             class="panel-group accordion"
             id="accordion-contact-mobile-navigation"
             role="tablist"
        >
          <div class="panel">
            <div class="panel-heading"
                 id="headingpanel-contact-mobile-navigation"
                 role="tab"
            >
              <h4>
                <mb-link [ariaControls]="'collapsepanel-contact-mobile-navigation'"
                         [ariaExpanded]="state.isExpanded"
                         [dataEventAction]="'Contact'"
                         [dataEventCategory]="'Accordion'"
                         [styleClass]="['mobile-entry', 'contact' ,(state.isExpanded ? 'collapsed' : '')]"
                         [linkData]="{uid: cmsLinkType.SPECIAL}"
                         [useSlot]="true"
                         (click)="isExpanded$.next(!state.isExpanded)"
                         dataToggle="collapse"
                         dataCy="navigation-categories-contact-box-list-item-link"
                         role="button"
                >
                <span>
                  <img [alt]="'shared.contact' | cxTranslate"
                       [title]="'shared.contact' | cxTranslate"
                       src="/assets/images/contact_mixed_white.svg"
                  >
                </span>
                  <span [innerHTML]="'navigation.contact' | cxTranslate"></span>
                </mb-link>
              </h4>
            </div>
            <div [@smoothCollapse]="state.isExpanded ? 'final' : 'initial'"
                 aria-labelledby="headingpanel-contact-mobile-navigation"
                 class="panel-collapse"
                 data-cy="navigation-categories-contact-box-wrapper"
                 id="collapsepanel-contact-mobile-navigation"
                 role="tabpanel"
            >
              <div class="panel-body contactInformation"
                   data-cy="navigation-categories-contact-box"
              >
                <mb-contact-box-navigation (closeContact)="contactClick.emit($event)"></mb-contact-box-navigation>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</ng-container>
